export default "__VITE_ASSET__06d150b3__"